import React from "react";
import { Card } from "@/components/ui/card";

const Kpi = ({ label, value, sub, testid, accent }) => (
  <Card className={`gold-ring glass border-t-4 p-4 text-center ${accent}`} data-testid={testid}>
    <p className="label-eyebrow">{label}</p>
    <p className="mt-2 font-display text-4xl font-800 text-[hsl(var(--gold))] sm:text-5xl">{value}</p>
    <p className="mt-1 text-[0.65rem] text-muted-foreground">{sub}</p>
  </Card>
);

export default function KpiStrip({ stats }) {
  const p = (n) => (stats.total ? `${Math.round((n * 100) / stats.total * 10) / 10}% of members` : "—");
  const d = stats.by_designation, s = stats.by_status;
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 xl:grid-cols-6" data-testid="population-kpis">
        <Kpi label="Total members" value={stats.total} sub={`Across ${Object.values(d).filter(Boolean).length} designations`} testid="kpi-total" accent="border-t-[hsl(var(--gold))]" />
        <Kpi label="Sailing" value={s.Sailing} sub={p(s.Sailing)} testid="kpi-sailing" accent="border-t-[#2E86DE]" />
        <Kpi label="On Spot" value={s.Spot} sub={p(s.Spot)} testid="kpi-spot" accent="border-t-[#F39C12]" />
        <Kpi label="Salted" value={d.Salted} sub={p(d.Salted)} testid="kpi-salted" accent="border-t-[hsl(var(--water))]" />
        <Kpi label="OSB" value={d.OSB} sub={p(d.OSB)} testid="kpi-osb" accent="border-t-[hsl(var(--water))]" />
        <Kpi label="ORB" value={d.ORB} sub={p(d.ORB)} testid="kpi-orb" accent="border-t-[hsl(var(--water))]" />
      </div>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3" data-testid="population-frigate-kpis">
        {stats.frigates.map((f) => (
          <Card key={f.label} className="gold-ring glass border-t-4 border-t-emerald-500 p-4 text-center" data-testid={`kpi-frigate-${f.label}`}>
            <p className="label-eyebrow">Frigate: {f.label}</p>
            <p className="mt-2 font-display text-4xl font-800 sm:text-5xl">{f.total}</p>
            <p className="mt-1 text-[0.65rem] text-muted-foreground">{f.pct}% of members | {f.Sailing} Sailing, {f.Spot} Spot{f.SWGP ? `, ${f.SWGP} SWGP` : ""}</p>
          </Card>
        ))}
      </div>
    </div>
  );
}
